import Button from "./Button";

const EmptyState = ({
  title = "Data belum tersedia",
  description = "Belum ada data yang bisa ditampilkan saat ini.",
  icon = "📭",
  actionLabel = "",
  onAction,
}) => {
  return (
    <div className="ui-empty-state">
      <div className="ui-empty-state__icon" aria-hidden="true">
        {icon}
      </div>

      <h3 className="ui-empty-state__title">{title}</h3>
      <p className="ui-empty-state__description">{description}</p>

      {actionLabel && onAction && (
        <div className="ui-empty-state__action">
          <Button onClick={onAction}>{actionLabel}</Button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;